export interface ICreateFreePass {
  Name: string;
  PaymentType: PASS_PAYMENT_TYPE;
  Type: PASS_TYPE;
  Period: IPassPeriod;
  AcademyId: string;
}

export interface ICreatePaidPass extends ICreateFreePass {
  Tax: number;
  Netto: number;
}

export interface IPass extends ICreatePaidPass {
  PassId: string;
  Gross: number;
  IsFree: boolean;
  AcademyId: string;
  IsAssignedToAnyPlayer: boolean;
  isActive?: boolean;
  Price: {
    Gross: number;
    Netto: number;
    Tax: number;
  };
}

export interface IPassAppliedProfile {
  ProfileId: string;
  Name: string;
}

export interface IPassDetail extends IPass {
  AppliedProfiles: IPassAppliedProfile[];
}

export interface IPassForm extends ICreatePaidPass {
  NettoString: string;
}

export interface IChangePassPrice {
  PassId: string;
  Tax: number;
  Netto: number;
  AcademyId?: string;
}

export interface IPassDto {
  PassId: string;
  Name: string;
}

export interface IPassPeriod {
  StartAt: Date | null;
  EndAt: Date | null;
}

export interface ITransactionPlayer {
  PlayerId: string;
  Name: string;
}

export interface IPassPrice {
  Tax: number;
  Netto: number;
  Gross: number;
}

export interface IPassTransaction {
  TransactionId: string;
  Number: string;
  ValitTo: Date;
  Player: ITransactionPlayer;
  Period: IPassPeriod;
  Pass: IPassDto;
  Price: IPassPrice;
  Status: PASS_TRANSACTION_STATUS;
  detailPassPermission?: boolean;
  IsBoughtAsCompany?: boolean;
  PaymentMethod: PASS_PAYMENT_METHOD;
  Academy: IACademy;
  Groups: IGroups[];
  SortOption?: number;
}

interface IACademy {
  AcademyId: string;
  Name: string;
}

interface IGroups {
  GroupId: string;
  Name: string;
}

export interface IPlayerHistoryPass {
  TransactionId: string;
  Number: string;
  Status: PASS_TRANSACTION_STATUS;
  CreatedAt: Date;
  PaidAt: Date;
  Period: IPassPeriod;
  Pass: IPassDto;
  Price: IPassPrice;
  Academy: IACademy;
}
export enum PASS_TRANSACTION_STATUS {
  "Zapłacony",
  "Oczekuje na zapłatę",
  "Windykacja",
  "Niezapłacony",
  "Zaległy",
  "Anulowany",
  "Wakacje",
}

export interface IPassCancel {
  AcademyId: string;
  PlayerId: string;
  TransactionId: string;
}

export interface IPassUpdateValue extends IPassCancel {
  PaymentMethod: number;
}

export interface IUpdateTransactionPrice extends IPassCancel {
  Tax: number;
  Netto: number;
}

export enum PASS_PAYMENT_METHOD {
  "Gotówka",
  "Przelew",
}

export enum PASSES_SORT_LIST {
  "Najnowsze",
  "Najstarsze",
}

export enum PASS_PAYMENT_TYPE {
  "Miesięcznie",
  "Ratalnie",
  "Jednorazowo",
}

export enum PASS_TYPE {
  "Nieokreślony",
  "Określony",
}

export enum PASS_PRICE_TYPE {
  "Płatny",
  "Darmowy",
}

export enum PAYMENT_METHOD {
  Gotówka = 0,
  JustWin = 1,
  Przelew = 2,
}

export interface IPass {
  PassId: string;
  Name: string;
  Tax: number;
  Netto: number;
  Gross: number;
  IsFree: boolean;
  PaymentType: number;
  Type: number;
  Period: IPassPeriod;
  IsAssignedToAnyPlayer: boolean;
  isHistory: boolean;
  StartAt?: string | null;
  EndAt?: string | null;
}

export interface IPassTransactionSummary {
  TotalAmount: number;
  PaidAmount: number;
  WaitingForPaymentAmount: number;
  OverdueAmount: number;
  VindicationAmount: number;
  NotPaidAmount: number;
}

export interface IGetPassTransactionsRequest {
  AcademyIds?: string[];
  GroupIds?: string[];
  MinPrice?: number;
  MaxPrice?: number;
  TransactionStatuses?: number[];
  PassId?: string;
  TransactionId?: string;
  FromDate?: string | null;
  ToDate?: string | null;
  ShouldFilterByAcademiesList?: boolean;
  SortOption?: number;
  pageNumber?: number;
  pageSize?: number;
  PageNumber?: number;
  PageSize?: number;
  SearchQuery?: string;
}

interface IPeriod {
  StartAt: Date | null;
  EndAt: Date | null;
}
export interface IPasses extends IPass {
  isHistorical: boolean;
  Period: IPeriod;
  // StartAt: Date | null;
  // EndAt: Date | null;
  isActive: boolean;
}
